import React from 'react';
import './OpenAccess.css';
import LibraryNavbar from '../../components/Library/LibraryNavbar';
import Footer from '../../components/Homepage/Footer/Footer';
import openAccessData from '../../data/openAccessData';

const OpenAccess = () => {
  React.useEffect(() => {
    // Set page title
    document.title = 'Open Access Resources - Central Library - Rayalaseema University';
    
    // Scroll to top when component mounts
    window.scrollTo(0, 0);
  }, []);

  const handleResourceClick = (link) => {
    window.open(link, '_blank', 'noopener,noreferrer');
  };

  return (
    <div id="openaccess-main-page">
      {/* Library-specific Navigation */}
      <LibraryNavbar />

      {/* Open Access Table Section */}
      <div id="openaccess-content-section">
        <div className="openaccess-container">
          <div className="openaccess-intro-text">
            <h2>Available Open Access Resources</h2>
          </div>
          
          <div className="openaccess-table-wrapper">
            <table className="openaccess-table">
              <thead>
                <tr>
                  <th>Sr. No.</th>
                  <th>Resource Title</th>
                  <th>Access Link</th>
                </tr>
              </thead>
              <tbody>
                {openAccessData.map(resource => (
                  <tr key={resource.id}>
                    <td className="openaccess-serial">{resource.serialNumber}</td>
                    <td className="openaccess-title">{resource.title}</td>
                    <td className="openaccess-link">
                      <button 
                        onClick={() => handleResourceClick(resource.link)}
                        className="openaccess-access-btn"
                        title={`Access ${resource.title}`}
                      >
                        Access Resource
                      </button>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>

          {/* Additional Information Section */}
          <div className="openaccess-info-section">
            <div className="openaccess-info-grid">
              <div className="openaccess-info-card">
                <h3>What is Open Access?</h3>
                <p>
                  Open access refers to free, immediate, online availability of research articles 
                  coupled with the rights to use these articles fully in the digital environment.
                </p>
              </div>
              <div className="openaccess-info-card">
                <h3>Benefits for Researchers</h3>
                <p>
                  Increased visibility, higher citation rates, faster dissemination of research, 
                  and broader impact across global academic communities.
                </p>
              </div>
              <div className="openaccess-info-card">
                <h3>Quality Assurance</h3>
                <p>
                  All listed resources maintain rigorous peer-review processes and editorial 
                  standards ensuring high-quality scholarly content.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default OpenAccess;